import { NumericTextField } from './numeric';
import { TextField, TextFieldProps } from '../main';

type InputType = TextFieldProps['type'];

export const getBaseCompByType = (type: InputType) =>
  type === 'number' ? NumericTextField : TextField;
